import { useEffect } from "react";
import Lenis from "lenis";

// Mounts Lenis once for the Tech route and drives it from its own RAF loop.
// In-page anchor links (#capabilities, #contact, …) scroll smoothly through
// Lenis and stop just below the fixed 80px nav. When the visitor prefers
// reduced motion, native scrolling is left untouched.
export default function SmoothScroll({ children }) {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.4,
      anchors: { offset: -80 },
    });

    let raf = 0;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return children;
}
